/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useState, useRef } from 'react';

export const usePopUp = () => {
    const [isPopUpOpen, setPopUpOpen] = useState(false);
    const popUpRef = useRef();

    const openPopup = (url) => {
        const width = 920;
        const height = 600;
        const left = window.screenX + (window.innerWidth - width) / 2;
        const top = window.screenY + (window.innerHeight - height) / 2;

        popUpRef.current = window.open(
            url,
            'auth0:authorize:popup',
            `left=${left},top=${top},width=${width},height=${height},resizable,scrollbars=yes,status=1`,
        );

        return popUpRef.current;
    };

    const handlePopUpFocus = () => {
        if (!popUpRef.current.closed) {
            popUpRef.current.focus();
        }
    };

    return {
        isPopUpOpen,
        setPopUpOpen,
        openPopup,
        handlePopUpFocus,
    };
};

export default {};
